"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../../errors");
const IInvoiceNumberContent_1 = require("../models/invoice/IInvoiceNumberContent");
const ISettingsField_1 = require("../models/invoice/ISettingsField");
const ISettingsFieldType_1 = require("../models/invoice/ISettingsFieldType");
const MAX_CUSTOM_FIELD_LENGTH = 11;
class InvoiceNumberFormatter {
    formatInvoiceNumber(invoiceNumSettings, customerName, transactionId) {
        let serialized;
        switch (invoiceNumSettings.invoiceNumberContent) {
            case IInvoiceNumberContent_1.IInvoiceNumberContent.TRANSACTION_ID:
                serialized = transactionId;
                break;
            case IInvoiceNumberContent_1.IInvoiceNumberContent.SEQUENTIAL_NUMBER:
                serialized = invoiceNumSettings.nextInvoiceNumber;
                break;
        }
        if (serialized === undefined) {
            throw new errors_1.Errors.OperationError(errors_1.OperationErrorCode.Required, invoiceNumSettings.invoiceNumberContent);
        }
        if (invoiceNumSettings.settingsFieldType == ISettingsFieldType_1.ISettingsFieldType.NONE) {
            const invoiceNumber = `${serialized}`;
            return invoiceNumber;
        }
        let customField;
        if (invoiceNumSettings.settingsField == ISettingsField_1.ISettingsField.CUSTOM) {
            if (invoiceNumSettings.customField === undefined) {
                throw new errors_1.Errors.OperationError(errors_1.OperationErrorCode.Required, 'customField');
            }
            customField = invoiceNumSettings.customField;
        }
        else if (invoiceNumSettings.settingsField == ISettingsField_1.ISettingsField.CUSTOMER_NAME) {
            if (customerName === undefined) {
                throw new errors_1.Errors.OperationError(errors_1.OperationErrorCode.Required, 'customerName');
            }
            customField = customerName;
        }
        else {
            throw new errors_1.Errors.OperationError(errors_1.OperationErrorCode.InvalidValue, 'settingsField');
        }
        const slicedCustomField = customField.slice(0, MAX_CUSTOM_FIELD_LENGTH);
        if (invoiceNumSettings.settingsFieldType == ISettingsFieldType_1.ISettingsFieldType.PREFIX) {
            const invoiceNumber = `${slicedCustomField}${serialized}`;
            return invoiceNumber;
        }
        else {
            const invoiceNumber = `${serialized}${slicedCustomField}`;
            return invoiceNumber;
        }
    }
}
exports.default = InvoiceNumberFormatter;
